<template>
  <div v-if="show">
    <vxe-modal v-model="show" :title="name" width="400" min-width="400" height="210" min-height="210" showFooter
      esc-closable mask-closable resize>
      <template v-slot>
        <el-form ref="form" size="small" :model="data" label-width="auto" label-position="top" :rules="rules">
          <el-form-item prop="name" label="仓库名称">
            <el-input v-model="data.name" placeholder="输入仓库名称" type="text"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:footer>
        <div style="text-align: center">
          <vxe-button status="primary" style="width: 100%" @click="save" v-loading="loading">确定</vxe-button>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      name: '',
      data: {},
      rules: {
        name: [{ required: true, trigger: 'blur', message: '输入仓库名称' }]
      },
      loading: false
    }
  },
  methods: {
    /** 打开界面方法 */
    display(data) {
      this.show = true
      this.data = this.$utils.clone(data.data, true)
      this.name = data.name
    },
    /** 保存方法 */
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = this.data
          this.$axios
            .post('/order/spaceName/create', params)
            .then(res => {
              if (res) {
                this.$message.success('新增成功')
                this.show = false
                this.$emit('init')
                this.$store.dispatch('getSpaceName')
              }
              this.loading = false
            })
            .catch(err => {
              console.log('新增失败', err)
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>